import React, { useState } from "react";

const faqs = [
  {
    question: "How does your platform help me sell my home hassle-free?",
    answer:
      "We take care of everything—property verification, professional video shoots, listing management, buyer screening, and site visit coordination—ensuring you sell without the usual stress or spam.",
  },
  {
    question: "What fees do I need to pay?",
    answer:
      "We charge a 1% commission from both the seller and the buyer, only after the deal is successfully closed. There are no upfront or hidden charges.",
  },
  {
    question: "What services do buyers get on your platform?",
    answer:
      "Buyers get access to verified listings, video tours, scheduled site visits, documentation support, and end-to-end guidance—making the buying process safe and seamless.",
  },
  {
    question: "Can I list my property for free?",
    answer:
      "Yes, listing your property on our platform is absolutely free. You only pay the 1% fee after the sale is finalized.",
  },
  {
    question: "How do you ensure listings are genuine?",
    answer:
      "Our team physically verifies each property, captures high-quality visuals, checks documentation, and ensures seller authenticity before making listings public.",
  },
  {
    question: "Do you offer legal or home loan assistance?",
    answer:
      "Yes, we assist both buyers and sellers with paperwork, legal checks, and connect them with trusted home loan providers for a smooth transaction.",
  },
];

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="max-w-[85rem] px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto">
      <div className="max-w-2xl mx-auto text-center mb-10 lg:mb-14">
        <h2
          style={{
            fontFamily: "Playfair Display, sans-serif",
          }}
          className="text-2xl font-bold md:text-4xl md:leading-tight text-[#7C3A21]   "
        >
          Your questions, answered
        </h2>
        <p
          style={{
            fontFamily: "Poppins, sans-serif",
          }}
          className="mt-1 text-gray-600 dark:text-neutral-400"
        >
          Answers to the most frequently asked questions.
        </p>
      </div>

      <div className="max-w-2xl mx-auto space-y-4">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className={`rounded-xl p-6 transition-all duration-300 ${
              activeIndex === index
                ? "bg-gray-100 dark:bg-white/10"
                : "bg-white dark:bg-transparent"
            }`}
          >
            <button
              onClick={() => toggle(index)}
              className="flex items-center justify-between w-full md:text-lg font-semibold text-start text-gray-800 rounded-lg transition hover:text-gray-500 focus:outline-none dark:text-neutral-200 dark:hover:text-neutral-400"
            >
              {faq.question}
              <svg
                className={`transition-transform duration-300 size-5 text-gray-600 dark:text-neutral-400 ${
                  activeIndex === index ? "rotate-180" : ""
                }`}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path d="M6 9l6 6 6-6" />
              </svg>
            </button>
            <div
              className={`mt-2 text-gray-800 dark:text-neutral-200 overflow-hidden transition-all duration-300 ${
                activeIndex === index ? "max-h-40" : "max-h-0"
              }`}
            >
              <p className="pt-2">{faq.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;
